import { toLonLat } from "ol/proj";
import { useMemo, useState } from "react";
import { RLayerVector } from "rlayers";
import { ReactNodeDialog } from '../../common/utils/dialogUtlities';
import { useTranslation } from 'react-i18next';
import DataTable from '../../common/components/DataTable';
import { createMapZone, removeMapZone, updateMapZone, useMapZones } from '../../reducers/mapZoneSlice';
import { RDraw } from 'rlayers/interaction';
import useNetwork from '../../common/hooks/networkHook';
import PropTypes from 'prop-types';

export const ZoneEditor = ({ show, onClose }) => {
    const { t } = useTranslation();
    const network = useNetwork();
    const [drawing, setDrawing] = useState(false);
    const [newZone, setNewZone] = useState();
    const zones = useMapZones();

    const zoneColumns = t => [
        { title: t('name'), type: "text", editable: false, readonly: true, maxlength: 255, field: "name", required: true },
        { title: t('group'), type: "text", editable: true, field: "group", maxlength: 128 },
        { title: t('visible'), type: "checkbox", editable: true, field: "visible" },
        { title: t('zIndex'), type: "number", min: 0, step: 1, editable: true, field: "zindex", required: true },
        { title: t('color'), type: "colorpicker", editable: true, field: "color" },
        { title: t('width'), type: "number", min: 0, step: 1, editable: true, field: "width" },
        { title: t('opacity'), type: "range", min: 0, step: 0.05, max: 1, editable: true, field: "opacity" }
    ];

    const columns = useMemo(() => zoneColumns(t), [t]);

    const newDefault = useMemo(() => ({ color: '#000000', zindex: 1, opacity: 0.2, width: 2 }), []);

    const footerColumns = useMemo(() => {
        const def = zoneColumns(t);
        def[0].editable = true;
        def[0].readonly = false;
        return def;
    }, [t]);

    const handleDelete = entry => {
        removeMapZone(network, entry.id);
    };
    const handleUpdate = (zone, field, value) => {
        const delta = { id: zone.id };
        delta[field] = value;
        updateMapZone(network, delta);
    };
    const handleDraw = newZone => {
        setNewZone(newZone);
        setDrawing(true);
    };
    const handleAdd = event => {
        newZone.zone = event.feature.getGeometry().getCoordinates()[0].map(c => toLonLat(c));
        setDrawing(false);
        createMapZone(network, newZone);
        setNewZone();
    };

    return <>
        <ReactNodeDialog title="Edit Map Zones" size="lg" showModal={!drawing && show} onClose={() => { setDrawing(false); onClose(); }}>
            <DataTable columns={columns} footerColumns={footerColumns} defaultSort={['name']} value={zones} newDefault={newDefault} onAdd={handleDraw} onRemove={handleDelete} onUpdate={handleUpdate}></DataTable>
        </ReactNodeDialog>
        {drawing ? <RLayerVector zIndex={1000}><RDraw type="Polygon" onDrawEnd={handleAdd} onDrawAbort={() => { setNewZone(); setDrawing(false); }}></RDraw></RLayerVector> : null}
    </>;
};

ZoneEditor.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func
}